<template>
  <div>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.leave_area }}
      </template>
      <ul
        class="form__list form__list--compact form__list-top"
        v-for="(room, index) in rooms"
        :key="index"
      >
        <li class="form__item form__item--default form__item--1/4">
          {{
            facilityTypes && facilityTypes[room] && facilityTypes[room]["value"]
          }}
          <span v-if="room == 'other'">{{
            locales && locales.properties && locales.properties.rooms
          }}</span>
          <input
            type="hidden"
            :name="`leaveArea[` + room + `][name_nl]`"
            :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['nl']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
          />
          <input
            type="hidden"
            :name="`leaveArea[` + room + `][name_en]`"
            :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['en']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
          />
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea[room].width"
            valid-scope="modal-form"
            :name="`leaveArea[` + room + `][width]`"
            label=""
            @input="calculateSurface(leaveArea, room, 'leaveArea')"
          ></v-numeric-field-public>
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea[room].length"
            valid-scope="modal-form"
            :name="`leaveArea[` + room + `][length]`"
            label=""
            @input="calculateSurface(leaveArea, room, 'leaveArea')"
          ></v-numeric-field-public>
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea[room].surface"
            valid-scope="modal-form"
            :name="`leaveArea[` + room + `][surface]`"
            label=""
            @input="countLeaveAreaPoints(leaveArea)"
            :IsExtraInfo="true"
          >
            <template slot="extra-info"> m<sup>2</sup> </template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.toilet_in_shower_or_bathroom
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input type="hidden" name="leaveArea[include_shower]" value="0" />
          <v-checkboxes-public
            id="includeShower"
            @input="countLeaveAreaPoints(leaveArea)"
            label=""
            :is-single-checkbox="true"
            name="leaveArea[include_shower]"
            v-model="leaveArea.include_shower"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="leaveArea.include_shower == 1">
            <input type="hidden" name="leaveArea[include_shower]" value="1" />
            -1
          </template>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.leave_area }}
          {{ locales && locales.common && locales.common.total }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea.total"
            valid-scope="modal-form"
            name="leaveArea[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>

    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.other_spaces }}
      </template>
      <ul
        class="form__list form__list--compact form__list-top"
        v-for="(room, index) in otherRooms"
        :key="index"
      >
        <li class="form__item form__item--default form__item--1/4">
          <span v-if="room == 'other'">{{
            locales && locales.properties && locales.properties.other_spaces
          }}</span>
          <span v-else>{{
            facilityTypes && facilityTypes[room] && facilityTypes[room]["value"]
          }}</span>
          <input
            type="hidden"
            :name="`otherSpaces[` + room + `][name_nl]`"
            :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['nl']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
          />
          <input
            type="hidden"
            :name="`otherSpaces[` + room + `][name_en]`"
            :value="
              (facilityTypes[room] && facilityTypes[room]['value_lang']['en']) +
              (room == 'other'
                ? locales && locales.properties && locales.properties.rooms
                : '')
            "
          />
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="otherSpaces[room].width"
            valid-scope="modal-form"
            :name="`otherSpaces[` + room + `][width]`"
            label=""
            @input="calculateSurface(otherSpaces, room, 'otherSpaces')"
          ></v-numeric-field-public>
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="otherSpaces[room].length"
            valid-scope="modal-form"
            :name="`otherSpaces[` + room + `][length]`"
            label=""
            @input="calculateSurface(otherSpaces, room, 'otherSpaces')"
          ></v-numeric-field-public>
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="otherSpaces[room].surface"
            valid-scope="modal-form"
            :name="`otherSpaces[` + room + `][surface]`"
            label=""
            @input="countOtherSpacesPoints(otherSpaces)"
            :IsExtraInfo="true"
          >
            <template slot="extra-info"> m<sup>2</sup> </template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.attic_no_staircase
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="otherSpaces[attic_no_staircase]"
            value="0"
          />
          <v-checkboxes-public
            id="attic_no_staircase"
            @input="countOtherSpacesPoints(otherSpaces)"
            label=""
            :is-single-checkbox="true"
            name="otherSpaces[attic_no_staircase]"
            v-model="otherSpaces.attic_no_staircase"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="otherSpaces.attic_no_staircase == 1">
            <input
              type="hidden"
              name="otherSpaces[attic_no_staircase]"
              value="1"
            />
            -5
          </template>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.other_spaces }}
          {{ locales && locales.common && locales.common.total }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="otherSpaces.total"
            valid-scope="modal-form"
            name="otherSpaces[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>

    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.heating }} ({{
          locales && locales.properties && locales.properties.central_heating
        }})
      </template>
      <template v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <ul class="form__list form__list-top">
          <li class="form__item">
            <v-radios-public
              @input="countHeatingPoints"
              label=""
              v-model="heatingTypeClone"
              name="heating[type]"
              :extra-styling-is-enabled="true"
              class="form__item--full-width"
              :options="{
                '0':
                  locales &&
                  locales.properties &&
                  locales.properties.separate_heater,
                '1':
                  locales &&
                  locales.properties &&
                  locales.properties.individual_boiler,
                '2':
                  locales &&
                  locales.properties &&
                  locales.properties.collective_heating,
              }"
            >
            </v-radios-public>
          </li>
        </ul>
        <ul
          class="form__list form__list-top"
          v-if="heatingTypeClone && heatingTypeClone != 0"
        >
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.number_of_heated_rooms
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              v-model="heating.heated_rooms"
              valid-scope="modal-form"
              name="heating[heated_rooms]"
              label=""
              @input="countHeatingPoints"
              :precision="0"
              :IsExtraInfo="true"
            >
              <template slot="extra-info" v-if="heating.heated_rooms">{{
                heating.heated_rooms_points
              }}</template>
            </v-numeric-field-public>
          </li>
        </ul>
        <ul
          class="form__list form__list-top"
          v-if="heatingTypeClone && heatingTypeClone != 0"
        >
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.number_of_other_rooms_with_heating
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              v-model="heating.other_rooms_with_heating"
              valid-scope="modal-form"
              name="heating[other_rooms_with_heating]"
              label=""
              @input="countHeatingPoints"
              :precision="0"
              :IsExtraInfo="true"
            >
              <template
                slot="extra-info"
                v-if="heating.other_rooms_with_heating"
                >{{ heating.other_rooms_with_heating_points }}</template
              >
            </v-numeric-field-public>
          </li>
        </ul>
      </template>
      <template v-else>
        <ul class="form__list form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.number_of_heated_rooms
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              v-model="heating.heated_rooms"
              valid-scope="modal-form"
              name="heating[heated_rooms]"
              label=""
              @input="countHeatingPoints"
              :precision="0"
              :IsExtraInfo="true"
            >
              <template slot="extra-info" v-if="heating.heated_rooms">{{
                heating.heated_rooms_points
              }}</template>
            </v-numeric-field-public>
          </li>
        </ul>
        <ul class="form__list form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.number_of_cooled_rooms
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              v-model="heating.cooled_rooms"
              valid-scope="modal-form"
              name="heating[cooled_rooms]"
              label=""
              @input="countHeatingPoints"
              :precision="0"
              :IsExtraInfo="true"
            >
              <template slot="extra-info" v-if="heating.cooled_rooms">{{
                heating.cooled_rooms_points
              }}</template>
            </v-numeric-field-public>
          </li>
        </ul>
        <ul class="form__list form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.number_of_other_heated_rooms
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              v-model="heating.other_rooms_with_heating"
              valid-scope="modal-form"
              name="heating[other_rooms_with_heating]"
              label=""
              @input="countHeatingPoints"
              :precision="0"
              :IsExtraInfo="true"
            >
              <template slot="extra-info" v-if="heating.other_rooms_with_heating">{{
                heating.other_rooms_with_heating_points
              }}</template>
            </v-numeric-field-public>
          </li>
        </ul>
        <ul class="form__list form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.number_of_other_cooled_rooms
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              v-model="heating.other_rooms_with_cooling"
              valid-scope="modal-form"
              name="heating[other_rooms_with_cooling]"
              label=""
              @input="countHeatingPoints"
              :precision="0"
              :IsExtraInfo="true"
            >
              <template slot="extra-info" v-if="heating.other_rooms_with_cooling">{{
                heating.other_rooms_with_cooling_points
              }}</template>
            </v-numeric-field-public>
          </li>
        </ul>
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_heating
          }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="heating.total"
            valid-scope="modal-form"
            name="heating[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{
          locales && locales.properties && locales.properties.energy_performance
        }}
      </template>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.property_type
          }}
        </li>
        <li class="form__item form__item--1/4">
          <v-radios-public
            v-model="energy.property_type"
            name="energy[property_type]"
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.single_family_home,
              '2':
                locales &&
                locales.properties &&
                locales.properties.multi_family_home,
            }"
            @input="countEnergyPoints"
          ></v-radios-public>
        </li>
      </ul>
      <template v-if="energy.energy_performance_fee != 1">
        <ul class="form__list form__list--radios form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales && locales.properties && locales.properties.energy_label
            }}
          </li>
          <li class="form__item">
            <v-radios-public
              v-model="energy.energy_label"
              name="energy[energy_label]"
              :options="energyLabelsOptions"
              :sort="true"
              sort-by="custom"
              :custom-order="energyLabelsCustomOrder"
              @input="countEnergyPoints"
            ></v-radios-public>
            <strong
              v-if="
                energy.energy_label &&
                energyLabels[energy.energy_label] &&
                energyLabels[energy.energy_label]['slug'] != 'no_label_or_index'
              "
            >
              {{ energy.energy_points }}
            </strong>
          </li>
        </ul>
        <ul
          class="form__list form__list-top"
          v-if="
            energy.energy_label &&
            energyLabels[energy.energy_label] &&
            energyLabels[energy.energy_label]['slug'] == 'no_label_or_index'
          "
        >
          <li class="form__item form__item--1/4">
            {{
              locales &&
              locales.properties &&
              locales.properties.construction_year
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-textfield-public
              @input="countEnergyPoints"
              label=""
              v-model="energy.building_construction_year"
              name="energy[building_construction_year]"
              :IsExtraInfo="true"
            >
              <template
                slot="extra-info"
                v-if="energy.building_construction_year"
                >{{ energy.energy_points }}</template
              >
            </v-textfield-public>
          </li>
        </ul>
      </template>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.energy_performance_fee
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="energy[energy_performance_fee]"
            value="0"
          />
          <v-checkboxes-public
            id="energy_performance_fee"
            @input="countEnergyPoints"
            label=""
            :is-single-checkbox="true"
            name="energy[energy_performance_fee]"
            v-model="energy.energy_performance_fee"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="energy.energy_performance_fee == 1">
            <input
              type="hidden"
              name="energy[energy_performance_fee]"
              value="1"
            />
            {{ energy.energy_points }}
          </template>
        </li>
      </ul>
      <ul class="form__list form__list--checkboxes form__list-top" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.monument_allowance_energy
          }}
        </li>

        <li class="form__item form__item--1/4">
          <input type="hidden" name="monument_allowance" value="0" />
          <v-checkboxes-public
            id="monumentAllowance"
            @input="countEnergyPoints"
            label=""
            :is-single-checkbox="true"
            name="monument_allowance[value]"
            v-model="monumentAllowance.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.total_energy }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="energy.total"
            valid-scope="modal-form"
            name="energy[total]"
            label=""
            :precision="2"
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.kitchen }}
      </template>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.worktop_length
          }}
        </li>
        <li class="form__item">
          <v-radios-public
            v-model="kitchen.worktop_length.value"
            name="kitchen[worktop_length]"
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.less_than_1_meter,
              '2':
                locales &&
                locales.properties &&
                locales.properties['1_2_meters'],
              '3':
                locales &&
                locales.properties &&
                locales.properties.more_than_2_meters,
            }"
            @input="countKitchenPoints"
          ></v-radios-public>
          <strong v-if="kitchen.worktop_length.value">
            {{ kitchen.worktop_length.total }}
          </strong>
        </li>
      </ul>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.cooker }}
        </li>
        <li class="form__item" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
          <v-radios-public
            v-model="kitchen.cooker.value"
            name="kitchen[cooker]"
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_hob,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_hob_luxury,
              '3':
                locales &&
                locales.properties &&
                locales.properties.built_in_ceramic_hob,
            }"
            @input="countKitchenPoints"
          ></v-radios-public>
          <strong v-if="kitchen.cooker.value">
            {{ kitchen.cooker.total }}
          </strong>
        </li>
        <li class="form__item" v-else>
          <v-radios-public
            v-model="kitchen.cooker.value"
            name="kitchen[cooker]"
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_gas_hob,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_ceramic_hob,
              '3':
                locales &&
                locales.properties &&
                locales.properties.built_in_induction_hob,
            }"
            @input="countKitchenPoints"
          ></v-radios-public>
          <strong v-if="kitchen.cooker.value">
            {{ kitchen.cooker.total }}
          </strong>
        </li>
      </ul>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.oven }}
        </li>
        <li class="form__item">
          <v-radios-public v-if="(new Date(independantSettings.up_to_date) < newVersion)"
            v-model="kitchen.oven.value"
            name="kitchen[oven]"
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_oven,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_oven_including_hob,
            }"
            @input="countKitchenPoints"
          ></v-radios-public>
          <v-radios-public v-else
            v-model="kitchen.oven.value"
            name="kitchen[oven]"
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_gas_oven,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_electric_oven,
            }"
            @input="countKitchenPoints"
          ></v-radios-public>
          <strong v-if="kitchen.oven.value">
            {{ kitchen.oven.total }}
          </strong>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.built_in_microwave
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input type="hidden" name="kitchen[built_in_microwave]" value="0" />
          <v-checkboxes-public
            id="built_in_microwave"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[built_in_microwave]"
            v-model="kitchen.built_in_microwave.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="kitchen.built_in_microwave.value == 1">{{
            kitchen.built_in_microwave.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.built_in_extractor_hood
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="kitchen[built_in_extractor_hood]"
            value="0"
          />
          <v-checkboxes-public
            id="built_in_extractor_hood"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[built_in_extractor_hood]"
            v-model="kitchen.built_in_extractor_hood.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="kitchen.built_in_extractor_hood.value == 1">{{
            kitchen.built_in_extractor_hood.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.built_in_fridge
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input type="hidden" name="kitchen[built_in_fridge]" value="0" />
          <v-checkboxes-public
            id="built_in_fridge"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[built_in_fridge]"
            v-model="kitchen.built_in_fridge.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="kitchen.built_in_fridge.value == 1">{{
            kitchen.built_in_fridge.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.built_in_freezer
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/4"
        >
          <input type="hidden" name="kitchen[built_in_freezer]" value="0" />
          <v-checkboxes-public
            id="built_in_freezer"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[built_in_freezer]"
            v-model="kitchen.built_in_freezer.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="kitchen.built_in_freezer.value == 1">{{
            kitchen.built_in_freezer.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.built_in_freezer_fridge_combination
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="kitchen[built_in_freezer_fridge_combination]"
            value="0"
          />
          <v-checkboxes-public
            id="built_in_freezer_fridge_combination"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[built_in_freezer_fridge_combination]"
            v-model="kitchen.built_in_freezer_fridge_combination.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template
            v-if="kitchen.built_in_freezer_fridge_combination.value == 1"
            >{{ kitchen.built_in_freezer_fridge_combination.total }}</template
          >
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.built_in_dishwasher
          }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/4"
        >
          <input type="hidden" name="kitchen[built_in_dishwasher]" value="0" />
          <v-checkboxes-public
            id="built_in_dishwasher"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[built_in_dishwasher]"
            v-model="kitchen.built_in_dishwasher.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="kitchen.built_in_dishwasher.value == 1">{{
            kitchen.built_in_dishwasher.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.double_sink }}
        </li>
        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/4"
        >
          <input type="hidden" name="kitchen[double_sink]" value="0" />
          <v-checkboxes-public
            id="double_sink"
            @input="countKitchenPoints"
            label=""
            :is-single-checkbox="true"
            name="kitchen[double_sink]"
            v-model="kitchen.double_sink.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="kitchen.double_sink.value == 1">{{
            kitchen.double_sink.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.luxury_mixer_tap
          }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.luxury_mixer_tap.value"
            valid-scope="modal-form"
            name="kitchen[luxury_mixer_tap]"
            label=""
            :precision="0"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template slot="extra-info" v-if="kitchen.luxury_mixer_tap.value">{{
              kitchen.luxury_mixer_tap.total
            }}</template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.thermostatic_water_mixer
          }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.thermostatic_water_mixer.value"
            valid-scope="modal-form"
            name="kitchen[thermostatic_water_mixer]"
            label=""
            :precision="0"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="kitchen.thermostatic_water_mixer.value"
              >{{ kitchen.thermostatic_water_mixer.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.extra_single_cupboard
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.extra_single_cupboard.value"
            valid-scope="modal-form"
            name="kitchen[extra_single_cupboard]"
            label=""
            :precision="0"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="kitchen.extra_single_cupboard.value"
              >{{ kitchen.extra_single_cupboard.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.extra_double_closet
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.extra_double_closet.value"
            valid-scope="modal-form"
            name="kitchen[extra_double_closet]"
            label=""
            :precision="0"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="kitchen.extra_double_closet.value"
              >{{ kitchen.extra_double_closet.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.extra_wall_tiling
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.extra_wall_tiling.value"
            valid-scope="modal-form"
            name="kitchen[extra_wall_tiling]"
            label=""
            :precision="2"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="kitchen.extra_wall_tiling.value"
              >{{ kitchen.extra_wall_tiling.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.floor_tiles }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.floor_tiles.value"
            valid-scope="modal-form"
            name="kitchen[floor_tiles]"
            label=""
            :precision="2"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template slot="extra-info" v-if="kitchen.floor_tiles.value">{{
              kitchen.floor_tiles.total
            }}</template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.overall_luxury_version
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.overall_luxury_version.value"
            valid-scope="modal-form"
            name="kitchen[overall_luxury_version]"
            label=""
            :precision="0"
            @input="countKitchenPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="kitchen.overall_luxury_version.value"
              >{{ kitchen.overall_luxury_version.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_kitchen
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchen.total"
            valid-scope="modal-form"
            name="kitchen[total]"
            label=""
            :precision="2"
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.sanitary }}
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.number_of_toilets
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-textfield-public
            @input="countSanitaryPoints"
            label=""
            v-model="sanitary.number_of_toilets.value"
            name="sanitary[number_of_toilets]"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="sanitary.number_of_toilets.value"
              >{{ sanitary.number_of_toilets.total }}</template
            >
          </v-textfield-public>
        </li>
        </ul>
          <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) >= newVersion) && sanitary.number_of_toilets.value > 0">
            <li class="form__item form__item--1/4">
              {{
                locales &&
                locales.properties &&
                locales.properties.number_of_hunged_toilets
              }}
            </li>

            <li class="form__item form__item--1/4">
              <v-textfield-public
                @input="countSanitaryPoints"
                label=""
                v-model="sanitary.number_of_hunged_toilets.value"
                name="sanitary[number_of_hunged_toilets]"
                :IsExtraInfo="true"
              >
                <template
                  slot="extra-info"
                  v-if="sanitary.number_of_hunged_toilets.value"
                  >{{ sanitary.number_of_hunged_toilets.total }}</template
                >
              </v-textfield-public>
            </li>
          </ul>
          <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) >= newVersion) && sanitary.number_of_toilets.value > 0">
            <li class="form__item form__item--1/4">
              {{
                locales &&
                locales.properties &&
                locales.properties.number_of_separate_toilets
              }}
            </li>

            <li class="form__item form__item--1/4">
              <v-textfield-public
                @input="countSanitaryPoints"
                label=""
                v-model="sanitary.number_of_separate_toilets.value"
                name="sanitary[number_of_separate_toilets]"
                :IsExtraInfo="true"
              >
                <template
                  slot="extra-info"
                  v-if="sanitary.number_of_separate_toilets.value"
                  >{{ sanitary.number_of_separate_toilets.total }}</template
                >
              </v-textfield-public>
            </li>
          </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.number_of_washbasins
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-textfield-public
            @input="countSanitaryPoints"
            label=""
            v-model="sanitary.number_of_washbasins.value"
            name="sanitary[number_of_washbasins]"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="sanitary.number_of_washbasins.value"
              >{{ sanitary.number_of_washbasins.total }}</template
            >
          </v-textfield-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          <v-radios-public
            @input="countSanitaryPoints"
            label=""
            name="sanitary[shower_bath]"
            v-model="sanitary.shower_bath.value"
            :options="{
              '0':
                locales &&
                locales.properties &&
                locales.properties.no_shower_or_bath,
              '1':
                locales &&
                locales.properties &&
                locales.properties.shower_available,
              '2':
                locales &&
                locales.properties &&
                locales.properties.bath_available,
              '3':
                locales &&
                locales.properties &&
                locales.properties.separate_bath_and_shower_in_one_room,
            }"
          >
          </v-radios-public>
        </li>

        <li class="form__item form__item--1/4">
          <strong v-if="sanitary.shower_bath.value">{{
            sanitary.shower_bath.total
          }}</strong>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.cupboard_with_built_in_washbasin
          }}
        </li>

        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="sanitary[cupboard_with_built_in_washbasin]"
            value="0"
          />
          <v-checkboxes-public
            id="cupboard_with_built_in_washbasin"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[cupboard_with_built_in_washbasin]"
            v-model="sanitary.cupboard_with_built_in_washbasin.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template
            v-if="sanitary.cupboard_with_built_in_washbasin.value == 1"
            >{{ sanitary.cupboard_with_built_in_washbasin.total }}</template
          >
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.toilet_cabinet_with_built_in_lighting
          }}
        </li>

        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="sanitary[toilet_cabinet_with_built_in_lighting]"
            value="0"
          />
          <v-checkboxes-public
            id="toilet_cabinet_with_built_in_lighting"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[toilet_cabinet_with_built_in_lighting]"
            v-model="sanitary.toilet_cabinet_with_built_in_lighting.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template
            v-if="sanitary.toilet_cabinet_with_built_in_lighting.value == 1"
            >{{
              sanitary.toilet_cabinet_with_built_in_lighting.total
            }}</template
          >
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.extra_for_a_bubble_bath
          }}
        </li>

        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="sanitary[extra_for_a_bubble_bath]"
            value="0"
          />
          <v-checkboxes-public
            id="extra_for_a_bubble_bath"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[extra_for_a_bubble_bath]"
            v-model="sanitary.extra_for_a_bubble_bath.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="sanitary.extra_for_a_bubble_bath.value == 1">{{
            sanitary.extra_for_a_bubble_bath.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.sliding_or_folding_wall_with_aluminium_frame
          }}
        </li>

        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input
            type="hidden"
            name="sanitary[sliding_or_folding_wall_with_aluminium_frame]"
            value="0"
          />
          <v-checkboxes-public
            id="sliding_or_folding_wall_with_aluminium_frame"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[sliding_or_folding_wall_with_aluminium_frame]"
            v-model="
              sanitary.sliding_or_folding_wall_with_aluminium_frame.value
            "
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template
            v-if="
              sanitary.sliding_or_folding_wall_with_aluminium_frame.value == 1
            "
            >{{
              sanitary.sliding_or_folding_wall_with_aluminium_frame.total
            }}</template
          >
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.mounted_complete_separation_of_shower
          }}
        </li>

        <li class="form__item form__item--checkboxes-extra-info form__item--1/8">
          <input
            type="hidden"
            name="sanitary[mounted_complete_separation_of_shower]"
            value="0"
          />
          <v-checkboxes-public
            id="mounted_complete_separation_of_shower"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[mounted_complete_separation_of_shower]"
            v-model="sanitary.mounted_complete_separation_of_shower.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="sanitary.mounted_complete_separation_of_shower.value == 1">
            {{ sanitary.mounted_complete_separation_of_shower.total }}
          </template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.towel_radiator
          }}
        </li>

        <li class="form__item form__item--checkboxes-extra-info form__item--1/8">
          <input
            type="hidden"
            name="sanitary[towel_radiator]"
            value="0"
          />
          <v-checkboxes-public
            id="towel_radiator"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[towel_radiator]"
            v-model="sanitary.towel_radiator.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="sanitary.towel_radiator.value == 1">
            {{ sanitary.towel_radiator.total }}
          </template>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.luxury_mixer_tap
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="sanitary.luxury_mixer_tap.value"
            valid-scope="modal-form"
            name="sanitary[luxury_mixer_tap]"
            label=""
            :precision="0"
            @input="countSanitaryPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="sanitary.luxury_mixer_tap.value"
              >{{ sanitary.luxury_mixer_tap.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.thermostatic_water_mixer
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="sanitary.thermostatic_water_mixer.value"
            valid-scope="modal-form"
            name="sanitary[thermostatic_water_mixer]"
            label=""
            :precision="0"
            @input="countSanitaryPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="sanitary.thermostatic_water_mixer.value"
              >{{ sanitary.thermostatic_water_mixer.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.extra_wall_tiling
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="sanitary.extra_wall_tiling.value"
            valid-scope="modal-form"
            name="sanitary[extra_wall_tiling]"
            label=""
            :precision="2"
            @input="countSanitaryPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="sanitary.extra_wall_tiling.value"
              >{{ sanitary.extra_wall_tiling.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.overall_luxury_version
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="sanitary.overall_luxury_version.value"
            valid-scope="modal-form"
            name="sanitary[overall_luxury_version]"
            label=""
            :precision="0"
            @input="countSanitaryPoints"
            :IsExtraInfo="true"
          >
            <template
              slot="extra-info"
              v-if="sanitary.overall_luxury_version.value"
              >{{ sanitary.overall_luxury_version.total }}</template
            >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.power_outlet
          }}
        </li>

        <li class="form__item form__item--checkboxes-extra-info form__item--1/8">
          <input
            type="hidden"
            name="sanitary[power_outlet]"
            value="0"
          />
          <v-checkboxes-public
            id="power_outlet"
            @input="countSanitaryPoints"
            label=""
            :is-single-checkbox="true"
            name="sanitary[power_outlet]"
            v-model="sanitary.power_outlet.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="(new Date(independantSettings.up_to_date) >= newVersion && sanitary.power_outlet.value > 0)">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.number_of_power_outlets
          }}
        </li>
        <li class="form__item form__item--1/4">
              <v-textfield-public
                @input="countSanitaryPoints"
                label=""
                v-model="sanitary.number_of_power_outlet.value"
                name="sanitary[number_of_power_outlet]"
                :IsExtraInfo="true"
              >
                <template
                  slot="extra-info"
                  v-if="sanitary.number_of_power_outlet.value"
                  >{{ sanitary.power_outlet.total }}</template
                >
              </v-textfield-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_sanitary
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="sanitary.total"
            valid-scope="modal-form"
            name="sanitary[total]"
            label=""
            :precision="2"
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{
          locales &&
          locales.properties &&
          locales.properties.housing_for_disabled
        }}
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.disabled_total_investment
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="disabled.total_investment.value"
            valid-scope="modal-form"
            name="disabled[total_investment]"
            label=""
            @input="countDisabledPoints"
            :precision="2"
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.disabled_investment_subsidy
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="disabled.disabled_subsidy.value"
            valid-scope="modal-form"
            name="disabled[subsidy]"
            label=""
            @input="countDisabledPoints"
            :precision="2"
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.total_housing_for_disabled
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="disabled.total"
            valid-scope="modal-form"
            name="disabled[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
      <template slot="header">
        {{
          locales &&
          locales.properties &&
          locales.properties.shared_parking
        }}
      </template>
      <ul class="form__list form__list--radios form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales && locales.properties && locales.properties.shared_parking
            }}
          </li>
          <li class="form__item">
            <v-radios-public
              v-model="sharedParking.type"
              name="shared_parking[type]"
              :options="sharedParkingOptions"
              @input="countSharedParkingPoints"
            ></v-radios-public>
          </li>
        </ul>
        <ul class="form__list form__list-top">
          <li class="form__item form__item--1/4">
            {{
              locales && locales.properties && locales.properties.number_of_addresses
            }}
          </li>
          <li class="form__item form__item--1/4">
            <v-numeric-field-public
              @input="countSharedParkingPoints"
              v-model="sharedParking.number_of_addresses"
              valid-scope="modal-form"
              name="shared_parking[number_of_addresses]"
              label=""
            >
            </v-numeric-field-public>
          </li>
        </ul>
      
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_shared_parking
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="sharedParking.total"
            valid-scope="modal-form"
            name="shared_parking[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{
          locales &&
          locales.properties &&
          locales.properties.private_outdoor_space
        }}
      </template>
      <ul class="form__list form__list-top" :class="(new Date(independantSettings.up_to_date) < newVersion) ? 'form__list--radios ' : ''">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.private_outdoor_space
          }}
        </li>
        <li class="form__item" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
          <v-radios-public
            v-model="outdoor.space.value"
            name="outdoor[space]"
            :sort="true"
            sort-by="custom"
            :custom-order="outdoorSpacesCustomOrder"
            :options="outdoorSpacesOptions"
            @input="countOutdoorPoints"
          ></v-radios-public>
          <strong v-if="outdoor.space.value">
            {{ outdoor.space.total }}
          </strong>
        </li>
        <li class="form__item form__item--1/4" v-else>
          <v-numeric-field-public
            @input="countOutdoorPoints"
            v-model="outdoorSpacesArea"
            valid-scope="modal-form"
            name="outdoor[space_area]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) < newVersion)">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.carport }}
        </li>

        <li
          class="form__item form__item--checkboxes-extra-info form__item--1/8"
        >
          <input type="hidden" name="outdoor[carport]" value="0" />
          <v-checkboxes-public
            id="carport"
            @input="countOutdoorPoints"
            label=""
            :is-single-checkbox="true"
            name="outdoor[carport]"
            v-model="outdoor.carport.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          <template v-if="outdoor.carport.value">{{
            outdoor.carport.total
          }}</template>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.common_outdoor_space }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="outdoorCommonSpacesArea"
            @input="countOutdoorPoints"
            valid-scope="modal-form"
            name="outdoor[common_space_area]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="(new Date(independantSettings.up_to_date) >= newVersion)">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.common_outdoor_space_addresses }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            @input="countOutdoorPoints"
            v-model="outdoorCommonSpacesAddresses"
            valid-scope="modal-form"
            name="outdoor[common_space_addresses]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
      
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_outdoor
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="outdoor.total"
            valid-scope="modal-form"
            name="outdoor[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.vop }} ({{
          locales &&
          locales.common &&
          locales.common.minimum + " € " + independantMinVopPrice
        }})
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.enter_vop }}
        </li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="vop.price.value"
            valid-scope="modal-form"
            name="vop[price]"
            label=""
            @input="countVopPoints"
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list--checkboxes form__list-top">
        <li
          class="form__item form__item--1/4"
          v-html="
            locales &&
            locales.properties &&
            locales.properties.newly_built_renovated_house
          "
        ></li>

        <li class="form__item form__item--1/4">
          <input
            type="hidden"
            name="vop[newly_built_renovated_house]"
            value="0"
          />
          <v-checkboxes-public
            id="newly_built_renovated_house"
            @input="countVopPoints"
            label=""
            :is-single-checkbox="true"
            name="vop[newly_built_renovated_house]"
            v-model="vop.newly_built_renovated_house.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
        </li>
      </ul>
      <ul
        class="form__list form__list--radios form__list-top"
        v-if="vop.newly_built_renovated_house.value"
      >
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.delivery_in }}
        </li>
        <li class="form__item" v-if="new Date(independantSettings.up_to_date) < newVersion">
          <v-radios-public
            v-model="vop.delivery.value"
            name="vop[delivery]"
            :options="{
              2015: '2015',
              2016: '2016',
              2017: '2017',
              2018: '2018',
              2019: '2019',
              2020: '2020',
              2021: '2021',
            }"
            @input="countVopPoints"
          ></v-radios-public>
        </li>
        <li class="form__item" v-else>
          <v-radios-public
            v-model="vop.delivery.value"
            name="vop[delivery]"
            :options="{
              2018: '2018',
              2019: '2019',
              2020: '2020',
              2021: '2021',
              2022: '2022',
            }"
            @input="countVopPoints"
          ></v-radios-public>
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="vop.delivery.value > 2017">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.muncipality }}
        </li>
        <li class="form__item form__item--1/4">
          <v-autocomplete-custom
            :options="muncipalities"
            :initial="vop.location.value"
            v-model="vop.location.value"
            name="vop[location]"
            @input="countVopPoints"
            label=""
          >
          </v-autocomplete-custom>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.vop_absolute }}
        </li>

        <li class="form__item form__item--1/4">
          {{ vop.absolute }}
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.vop_surface_proportion
          }}
        </li>

        <li class="form__item form__item--1/4">
          {{ vop.surface_proportion }}
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.total_vop }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="vop.total"
            valid-scope="modal-form"
            name="vop[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }" v-if="new Date(independantSettings.up_to_date) < newVersion">
      <template slot="header">
        {{
          locales && locales.properties && locales.properties.renovatoin_points
        }}
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.investments_from
          }}
          1 {{ investmentsDate }}
          {{ investmentsYear }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="renovation.price.value"
            valid-scope="modal-form"
            name="renovation[price]"
            label=""
            @input="countRenovationPoints"
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_renovation
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="renovation.total"
            valid-scope="modal-form"
            name="renovation[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.care_home }}
      </template>
      <ul class="form__list form__list--checkboxes form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.care_home }}
        </li>

        <li class="form__item form__item--1/4">
          <input type="hidden" name="care_home[value]" value="0" />
          <v-checkboxes-public
            id="care_home"
            @input="countCareHomePoints"
            label=""
            :is-single-checkbox="true"
            name="care_home[value]"
            v-model="careHome.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
        </li>
      </ul>
      <ul class="form__list form__list--checkboxes form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.has_automatic_bell }}
        </li>
        <li class="form__item form__item--1/4">
          <input type="hidden" name="care_home[value]" value="0" />
          <v-checkboxes-public
            id="care_home_bell"
            @input="countCareHomePoints"
            label=""
            :is-single-checkbox="true"
            name="care_home[has_automatic_bell]"
            v-model="careHome.has_automatic_bell"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.total_care_home
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="careHome.total"
            valid-scope="modal-form"
            name="care_home[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }" v-if="new Date(independantSettings.up_to_date) < newVersion">
      <template slot="header">
        {{
          locales && locales.properties && locales.properties.monument_allowance
        }}
      </template>
      <ul class="form__list form__list--checkboxes form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.monument_allowance
          }}
        </li>

        <li class="form__item form__item--1/4">
          <input type="hidden" name="monument_allowance" value="0" />
          <v-checkboxes-public
            id="monumentAllowance"
            @input="countMonumentAllowancePoints"
            label=""
            :is-single-checkbox="true"
            name="monument_allowance[value]"
            v-model="monumentAllowance.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
        </li>
      </ul>
      <ul class="form__list form__list--checkboxes form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.total_monument_allowance
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="monumentAllowance.total"
            valid-scope="modal-form"
            name="monument_allowance[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card
      :is-open-responsive="{ desktop: true, mobile: true }"
      class="v-card--total v-card--sticky"
    >
      <template slot="header">
        {{ locales && locales.properties && locales.properties.total_points }}
      </template>
      <ul class="form__list">
        <li class="form__item form__item--total form__item--1/2">
          <ul class="form__list">
            <li class="form__item form__item--1/2">
              {{
                locales && locales.properties && locales.properties.total_points
              }}
            </li>
            <li class="form__item form__item--1/2">
              <v-numeric-field-public
                v-model="totalPoints"
                valid-scope="modal-form"
                name="total"
                label=""
              >
              </v-numeric-field-public>
            </li>
          </ul>
        </li>
        <li class="form__item form__item--total form__item--1/2">
          <ul class="form__list">
            <li class="form__item form__item--1/2">
              {{
                locales &&
                locales.properties &&
                locales.properties.max_basic_rent_price
              }}
            </li>
            <li class="form__item form__item--1/2">
              <v-numeric-field-public
                v-model="price"
                valid-scope="modal-form"
                name="price"
                label=""
              >
              </v-numeric-field-public>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item__btns-wrap">
          <button type="submit" class="form__button" style="margin-right:15px;">
            {{ locales && locales.common && locales.common.download_pdf }}
          </button>
          <button type="submit" name="submit" value="save" class="form__button">
                {{ locales && locales.common && locales.common.save }}
            </button>
        </li>
      </ul>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  computed: {
    ...mapGetters(["metadata", "locales"]),
  },
  data() {
    return {
      total: 0,
      totalPoints: 0,
      surface: 0,
      price: 0,
      heatingTypeClone: this.heatingType,
      outdoorSpacesArea: 0,
      outdoorCommonSpacesArea: 0,
      outdoorCommonSpacesAddresses: 0,
      newVersion: new Date('2024-07-01')
    };
  },
  props: {
    property: {
      default: () => {
        return {};
      },
      type: Object,
    },
    energyLabelsOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    energyLabelsCustomOrder: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    outdoorSpacesCustomOrder: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    energyLabels: {
      default: () => {
        return {};
      },
      type: Object,
    },
    energyLabelsBySlug: {
      default: () => {
        return {};
      },
      type: Object,
    },
    energyLabelsIdBySlug: {
      default: () => {
        return {};
      },
      type: Object,
    },
    outdoorSpaces: {
      default: () => {
        return {};
      },
      type: Object,
    },
    outdoorSpacesOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    independantLandlordSpendingsBase: {
      default: 0,
      type: [String, Number],
    },
    independantMinVopPrice: {
      default: 0,
      type: [String, Number],
    },
    independantVopPointPrice: {
      default: 0,
      type: [String, Number],
    },
    independantVopProportionPrice: {
      default: 0,
      type: [String, Number],
    },
    independantVopProportionPriceAmsterdamUtrecht: {
      default: 0,
      type: [String, Number],
    },
    independantMaxRentalPrices: {
      default: () => {
        return {};
      },
      type: [Array, Object],
    },
    independantSettings: {
      default: () => {
        return {};
      },
      type: [Array, Object],
    },
    muncipalities: {
      default: () => {
        return [];
      },
      type: Array,
    },
    heatingType: {
      default: null,
      type: [String, Number],
    },
    sharedParking: {
      default: () => {
        return {};
      },
      type: Object,
    },
    leaveArea: {
      default: () => {
        return {};
      },
      type: Object,
    },
    otherSpaces: {
      default: () => {
        return {};
      },
      type: Object,
    },
    heating: {
      default: () => {
        return {};
      },
      type: Object,
    },
    energy: {
      default: () => {
        return {};
      },
      type: Object,
    },
    kitchen: {
      default: () => {
        return {};
      },
      type: Object,
    },
    sanitary: {
      default: () => {
        return {};
      },
      type: Object,
    },
    disabled: {
      default: () => {
        return {};
      },
      type: Object,
    },
    outdoor: {
      default: () => {
        return {};
      },
      type: Object,
    },
    vop: {
      default: () => {
        return {};
      },
      type: Object,
    },
    renovation: {
      default: () => {
        return {};
      },
      type: Object,
    },
    careHome: {
      default: () => {
        return {};
      },
      type: Object,
    },
    monumentAllowance: {
      default: () => {
        return {};
      },
      type: Object,
    },
    facilityTypes: {
      default: () => {
        return {};
      },
      type: Object,
    },
    energyLabels: {
      default: () => {
        return {};
      },
      type: Object,
    },
    rooms: {
      default: () => {
        return [];
      },
      type: Array,
    },
    otherRooms: {
      default: () => {
        return [];
      },
      type: Array,
    },
    investmentsDate: {
      default: "",
      type: String,
    },
    investmentsYear: {
      default: "",
      type: String,
    },
    sharedParkingOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
  },
  beforeMount() {
    this.countSurface();
    this.countHeatingPoints();
    this.countEnergyPoints();
    this.countKitchenPoints();
    this.countSanitaryPoints();
    this.countDisabledPoints();
    this.countOutdoorPoints();
    if(new Date(this.independantSettings.up_to_date) >= this.newVersion){
      this.countSharedParkingPoints();
    }
    this.countVopPoints();
    if(new Date(this.independantSettings.up_to_date) < this.newVersion){
      this.countRenovationPoints();
    }
    this.countCareHomePoints();
    this.countMonumentAllowancePoints();
  },
  methods: {
    calculateSurface(object, room, group) {
      if(object && object[room]){
        var width = parseFloat((object[room].width + "").replace(",", "."));
        var length = parseFloat((object[room].length + "").replace(",", "."));
        var surface = width * length;

        Vue.set(object[room], "surface", surface);
        switch (group) {
          case "leaveArea":
            this.countLeaveAreaPoints(object);
            break;
          case "otherSpaces":
            this.countOtherSpacesPoints(object);
            break;
        }
      }
    },
    countLeaveAreaPoints(object) {
      var sum = 0;
      for (var ob in object) {
        if (ob != "total" && ob != "include_shower") {
          var room = object[ob];
          if (room.surface) {
            sum += Math.round(parseFloat((room.surface + "").replace(",", "."))) * parseFloat((this.independantSettings.price_points_settings.surface_points_per_m2 + "").replace(",", ".")); //1;
          }
        }
      }
      if(new Date(this.independantSettings.up_to_date) < this.newVersion){
        if (sum >= 1 && object.include_shower == true) {
          sum -= 1;
        } else if (object.include_shower == true) {
          sum = 0;
        }
      }
      var total = sum;
      Vue.set(object, "total", total);

      this.countSurface();
      this.countCareHomePoints();
      this.countTotal();
    },
    countOtherSpacesPoints(object) {
      var sum = 0;
      for (var ob in object) {
        if (ob != "total" && ob != "attic_no_staircase") {
          var room = object[ob];
          if (room.surface) {
            sum += Math.round(parseFloat((room.surface + "").replace(",", "."))) * parseFloat((this.independantSettings.price_points_settings.other_spaces_points_per_m2+'').replace(',', '.')); //0,75
          }
        }
      }
      if(new Date(this.independantSettings.up_to_date) < this.newVersion){
        if (sum >= 1 && object.attic_no_staircase == true) {
          sum -= 5;
        } else if (object.attic_no_staircase == true) {
          sum = 0;
        }
      }
      var total = sum;
      Vue.set(object, "total", total);

      this.countSurface();
      this.countCareHomePoints();
      this.countTotal();
    },
    countSurface() {
      var sum = 0;
      for (var ob in this.leaveArea) {
        if (this.leaveArea[ob] && this.leaveArea[ob].surface) {
          sum += Math.round(
            parseFloat((this.leaveArea[ob].surface + "").replace(",", "."))
          );
        }
      }

      for (var ob in this.otherSpaces) {
        if (this.otherSpaces[ob] && this.otherSpaces[ob].surface) {
          sum += Math.round(
            parseFloat((this.otherSpaces[ob].surface + "").replace(",", "."))
          );
        }
      }
      this.surface = sum;
    },
    countHeatingPoints() {
      var sum = 0;
      var heatingPoints = 0;
      var coolingPoints = 0;
      var otherHeatingPoints = 0;
      var otherCoolingPoints = 0;
      if(new Date(this.independantSettings.up_to_date) < this.newVersion){
        if (this.heatingTypeClone == 1) {
          heatingPoints = parseFloat(this.heating.heated_rooms + "") * parseFloat((this.independantSettings.price_points_settings.heating.individual_boiler_points_per_room+"").replace(',', '.')); //2
          sum += heatingPoints;
          var maxOtherPoints = parseFloat((this.independantSettings.price_points_settings.heating.max_other_heating_points+'').replace(',','.'));
          var cp = parseFloat(this.heating.other_rooms_with_heating + "") * parseFloat((this.independantSettings.price_points_settings.heating.individual_boiler_points_per_other_room_with_heating+'').replace(',','.')); //2;
          if (cp < maxOtherPoints) {
            otherHeatingPoints = cp;
          } else {
            otherHeatingPoints = maxOtherPoints; //4
          }
          sum += otherHeatingPoints;
        } else if (this.heatingTypeClone == 2) {
          heatingPoints = parseFloat(this.heating.heated_rooms + "") * parseFloat((this.independantSettings.price_points_settings.heating.collective_heating_points_per_room+'').replace(',', '.')); //1.5
          sum += heatingPoints;
          var maxOtherPoints = parseFloat((this.independantSettings.price_points_settings.heating.max_other_heating_points+'').replace(',', '.'));
          var cp = parseFloat(this.heating.other_rooms_with_heating + "") * parseFloat((this.independantSettings.price_points_settings.heating.collective_heating_points_per_other_room_with_heating+'').replace(',','.')); //2;
          if (cp < maxOtherPoints) {
            otherHeatingPoints =cp;
          } else {
            otherHeatingPoints = maxOtherPoints;
          }
          sum += otherHeatingPoints;
        }
      }else{
          heatingPoints = parseFloat(this.heating.heated_rooms + "") * parseFloat((this.independantSettings.price_points_settings.heating.points_per_room+'').replace(',', '.')); //1
          sum += heatingPoints;
          var maxOtherPoints = parseFloat((this.independantSettings.price_points_settings.heating.max_other_heating_points+'').replace(',', '.'));
          var hp = parseFloat(this.heating.other_rooms_with_heating + "") * parseFloat((this.independantSettings.price_points_settings.heating.points_per_other_room_with_heating+'').replace(',', '.')); //1;
          if (hp < maxOtherPoints) {
            otherHeatingPoints = hp;
          } else {
            otherHeatingPoints = maxOtherPoints;
          }
          sum += otherHeatingPoints;

          coolingPoints = parseFloat(this.heating.cooled_rooms + "")  * parseFloat((this.independantSettings.price_points_settings.heating.points_per_cooled_room+'').replace(',','.')); //1
          sum += coolingPoints;
          var maxOtherCoolingPoints = parseFloat((this.independantSettings.price_points_settings.heating.max_other_cooling_points+'').replace(',', '.'));//2
          var cp = parseFloat(this.heating.other_rooms_with_cooling + "") * parseFloat((this.independantSettings.price_points_settings.heating.points_per_other_room_with_cooling+'').replace(',', '.')); //1;
          if (cp < maxOtherCoolingPoints) {
            otherCoolingPoints = cp;
          } else {
            otherCoolingPoints = maxOtherCoolingPoints;
          }
          sum += otherCoolingPoints;
      }
      var total = sum;
      Vue.set(this.heating, "heated_rooms_points", heatingPoints);
      Vue.set(
        this.heating,
        "other_rooms_with_heating_points",
        otherHeatingPoints
      );
      Vue.set(this.heating, "cooled_rooms_points", coolingPoints);
      Vue.set(
        this.heating,
        "other_rooms_with_cooling_points",
        otherCoolingPoints
      );
      Vue.set(this.heating, "total", total);
      this.countCareHomePoints();
      this.countTotal();
    },
    countEnergyPoints() {
      var sum = 0;
      var energyPoints = 0;
      if (this.energy.energy_performance_fee == 1) {
        if (this.energy.property_type == 1) {
          energyPoints = parseFloat((this.independantSettings.price_points_settings.energy.energy_compensation.single_family+'').replace(',', '.')); //32
        } else if (this.energy.property_type == 2) {
          energyPoints = parseFloat((this.independantSettings.price_points_settings.energy.energy_compensation.multi_family+'').replace(',', '.')); //28
        }
        sum += energyPoints;
      } else {
        if(new Date(this.independantSettings.up_to_date) < this.newVersion){
          if (this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] != "no_label_or_index") {
            if (this.energy.property_type == 1) {
              energyPoints = parseFloat((this.energyLabels[this.energy.energy_label]["single_house_points"] + "").replace(',', '.'));
            } else if (this.energy.property_type == 2) {
              energyPoints = parseFloat((this.energyLabels[this.energy.energy_label]["multi_house_points"] + "").replace(',', '.'));
            }
          } else if (this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] == "no_label_or_index" && this.energy.building_construction_year) {
            if (this.energy.building_construction_year <= 1976) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_g"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_g"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1978) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_f"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_f"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1983) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_e"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_e"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1991) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_d"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_d"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1997) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_c"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_d"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1999) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_c"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_c"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 2001) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_b"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_b"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            } else if (this.energy.building_construction_year > 2001) {
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_a"]["single_house_points"] + ""
                ).replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((
                  this.energyLabelsBySlug["label_a"]["multi_house_points"] + ""
                ).replace(',', '.'));
              }
            }
          }
        }else{
          if(this.surface < 25 && this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] != "no_label_or_index"){
            if (this.energy.property_type == 1) {
              energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[this.energy.energy_label].single_family_below25+'').replace(',', '.'));
            }else if (this.energy.property_type == 2){
              energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[this.energy.energy_label].multi_family_below25+'').replace(',', '.'));
            }
          }else if(this.surface >= 25 && this.surface < 40 && this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] != "no_label_or_index"){
            if (this.energy.property_type == 1) {
              energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[this.energy.energy_label].single_family_between_25_and_40+'').replace(',', '.'));
            }else if (this.energy.property_type == 2){
              energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[this.energy.energy_label].multi_family_between_25_and_40+'').replace(',', '.'));
            }
          }else if(this.surface >= 40 && this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] != "no_label_or_index"){
            if (this.energy.property_type == 1) {
              energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[this.energy.energy_label].single_family+'').replace(',', '.'));
            }else if (this.energy.property_type == 2){
              energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[this.energy.energy_label].multi_family+'').replace(',', '.'));
            }
            console.log(this.energy.energy_label, energyPoints);
          }else if (this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] == "no_label_or_index" && this.energy.building_construction_year) {
            if (this.energy.building_construction_year <= 1976) {
              var labelG = this.energyLabelsIdBySlug["label_g"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelG].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelG].multi_family+'').replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1978) {
              var labelF = this.energyLabelsIdBySlug["label_f"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelF].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelF].multi_family+'').replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1983) {
              var labelE = this.energyLabelsIdBySlug["label_e"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelE].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelE].multi_family+'').replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1991) {
              var labelD = this.energyLabelsIdBySlug["label_d"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelD].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelD].multi_family+'').replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 1999) {
              var labelC = this.energyLabelsIdBySlug["label_c"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelC].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelC].multi_family+'').replace(',', '.'));
              }
            } else if (this.energy.building_construction_year <= 2001) {
              var labelB = this.energyLabelsIdBySlug["label_b"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelB].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelB].multi_family+'').replace(',', '.'));
              }
            } else if (this.energy.building_construction_year > 2001) {
              var labelA = this.energyLabelsIdBySlug["label_a"];
              if (this.energy.property_type == 1) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelA].single_family+'').replace(',', '.'));
              } else if (this.energy.property_type == 2) {
                energyPoints = parseFloat((this.independantSettings.price_points_settings.energy[labelA].multi_family+'').replace(',', '.'));
              }
            }
          }
          if (this.monumentAllowance.value && this.monumentAllowance.value == 1 && energyPoints < 0) {
            energyPoints = 0;
          }
        }
        sum += energyPoints;
      }
      var total = sum;
      Vue.set(this.energy, "energy_points", total);
      Vue.set(this.energy, "total", total);
      this.countCareHomePoints();
      this.countTotal();
    },
    countKitchenPoints() {
      var sum = 0;
      var maxPoints = 0;
      var addPoints = 0;
      if (this.kitchen.worktop_length.value == 2) {
        addPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_1_2m_points + "").replace(",", ".")); //4
        maxPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_1_2m_max_points + "").replace(",", ".")); //8
        
      } else if (this.kitchen.worktop_length.value == 3) {
        addPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_2m_points + "").replace(",", ".")); //7
        maxPoints = parseFloat((this.independantSettings.price_points_settings.kitchen.worktop_2m_max_points + "").replace(",", ".")); //14
      }
      Vue.set(this.kitchen.worktop_length, "points", addPoints);
      Vue.set(this.kitchen.worktop_length, "total", addPoints);
      sum += addPoints;

      for (var ob in this.kitchen) {
        var element = this.kitchen[ob];
        var points = 0;
        if (ob == "extra_wall_tiling" || ob == "floor_tiles") {
          if(new Date(this.independantSettings.up_to_date) < this.newVersion){
              points =
              parseFloat((element.points + "").replace(",", ".")) *
                Math.floor(parseFloat((element.value + "").replace(",", ".")) / 2);
              Vue.set(this.kitchen[ob], "total", points);
          }
        } else if (ob == "overall_luxury_version") {
          if(new Date(this.independantSettings.up_to_date) < this.newVersion){
            points = parseFloat((element.value+ "").replace(",", ".")) <= 2 ? parseFloat((element.value + "").replace(",", ".")) : 2;
            Vue.set(this.kitchen[ob], "total", points);
          }
        } else if (ob == "cooker") {
          if (element.value == 1) {
            points = parseFloat((this.independantSettings.price_points_settings.kitchen.gas_cooker_points + "").replace(",", ".")); //0.5
          } else if (element.value == 2) {
            points = parseFloat((this.independantSettings.price_points_settings.kitchen.ceramic_cooker_points + "").replace(",", ".")); //1
          } else if (element.value == 3) {
            points = parseFloat((this.independantSettings.price_points_settings.kitchen.induction_cooker_points + "").replace(",", ".")); //1.25
          }
          Vue.set(this.kitchen[ob], "total", points);
        } else if (ob == "oven") {
          if (element.value == 1) {
            points = parseFloat((this.independantSettings.price_points_settings.kitchen.gas_oven_points + "").replace(",", ".")); //0.75
          } else if (element.value == 2) {
            points = parseFloat((this.independantSettings.price_points_settings.kitchen.electric_oven_points + "").replace(",", ".")); //1.25
          }
          Vue.set(this.kitchen[ob], "total", points);
        } else if (ob != "total" && ob != "worktop_length") {
          if(new Date(this.independantSettings.up_to_date) < this.newVersion || new Date(this.independantSettings.up_to_date) >= this.newVersion && element.new == 1){
            points = parseFloat((element.points + "").replace(",", ".")) * Math.round(parseFloat((element.value + "").replace(",", ".")));
            Vue.set(this.kitchen[ob], "total", points);
          }
        }
        if (sum + points <= maxPoints) {
          sum += points;
        } else {
          sum = maxPoints;
        }
      }
      var total = sum;
      Vue.set(this.kitchen, "total", total);
      this.countCareHomePoints();
      this.countTotal();
    },
    countSanitaryPoints() {
      var sum = 0;
      var maxPoints = 0;
      var addPoints = 0;
     
      if (this.sanitary.shower_bath.value == 1) {
        addPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_points +'').replace(',', '.')); //4
        maxPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_max_points +'').replace(',', '.')); //8
      } else if (this.sanitary.shower_bath.value == 2) {
        addPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.bath_points +'').replace(',', '.')); //6
        maxPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.bath_max_points +'').replace(',', '.')); //12
      } else if (this.sanitary.shower_bath.value == 3) {
        addPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_bath_points +'').replace(',', '.')); //7
        maxPoints = parseFloat((this.independantSettings.price_points_settings.sanitary.shower_bath_max_points +'').replace(',', '.')); //14
      }
      Vue.set(this.sanitary.shower_bath, "points", addPoints);
      Vue.set(this.sanitary.shower_bath, "total", addPoints);
      sum += addPoints;

      if (this.sanitary.number_of_toilets.value) {
        var p = parseFloat((this.sanitary.number_of_toilets.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_toilets.value + "").replace(",", ".")));
        maxPoints += p;
        sum += p;
        Vue.set(this.sanitary.number_of_toilets, "total", p);
      }
      if (this.sanitary.number_of_washbasins.value) {
        var p = parseFloat((this.sanitary.number_of_washbasins.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_washbasins.value + "").replace(",", ".")));
        maxPoints += p;
        sum += p;
        Vue.set(this.sanitary.number_of_washbasins, "total", p);
      }
      for (var ob in this.sanitary) {
        var element = this.sanitary[ob];
        var points = 0;
        if (ob == "extra_wall_tiling") {
          if(new Date(this.independantSettings.up_to_date) < this.newVersion){
            points = parseFloat((element.points+'').replace(',', '.')) * Math.floor(parseFloat((element.value + "").replace(",", ".")) / 2);
            Vue.set(this.sanitary[ob], "total", points);
          }
        } else if (ob == "overall_luxury_version") {
          if(new Date(this.independantSettings.up_to_date) < this.newVersion){
            points = element.value <= 2 ? element.value : 2;
            Vue.set(this.sanitary[ob], "total", points);
          }
        } else if (ob == "power_outlet") {
          if(new Date(this.independantSettings.up_to_date) >= this.newVersion && element.new == 1){
            points = this.sanitary.number_of_power_outlet.value * parseFloat((element.points+'').replace(',', '.'));
            if(points > parseFloat((this.independantSettings.price_points_settings.sanitary.power_outlet_max_points+ "").replace(",", "."))){
              points = parseFloat((this.independantSettings.price_points_settings.sanitary.power_outlet_max_points+ "").replace(",", "."));
            }
            Vue.set(this.sanitary[ob], "total", points);
          }
        } else if (ob == "number_of_separate_toilets") {
          if(new Date(this.independantSettings.up_to_date) >= this.newVersion && element.new == 1){
            if(parseFloat((this.sanitary.number_of_toilets.value+'').replace(',', '.')) < parseFloat((this.sanitary.number_of_separate_toilets.value+'').replace(',', '.'))){
              var nt =  this.sanitary.number_of_toilets.value;
              Vue.set(this.sanitary.number_of_separate_toilets, "value", nt);
            }
            points = -(parseFloat((this.sanitary.number_of_toilets.value+'').replace(',', '.')) - parseFloat((this.sanitary.number_of_separate_toilets.value+'').replace(',', '.'))) * parseFloat((element.points+'').replace(',', '.'));
            
            Vue.set(this.sanitary[ob], "total", points);
          }
        } else if (
          ob != "total" &&
          ob != "number_of_toilets" &&
          ob != "number_of_separate_toilets" &&
          ob != "number_of_washbasins" &&
          ob != "number_of_power_outlet" &&
          ob != "shower_bath"
        ) {
          if(new Date(this.independantSettings.up_to_date) < this.newVersion && element.old == 1 || new Date(this.independantSettings.up_to_date) >= this.newVersion && element.new == 1){
            points = parseFloat((element.points+'').replace(',', '.')) * Math.round(parseFloat((element.value + "").replace(",", ".")));
            Vue.set(this.sanitary[ob], "total", points);
          }
        }
        if (sum + points <= maxPoints) {
          sum += points;
        } else {
          sum = maxPoints;
        }
      }
      var total = sum;
      Vue.set(this.sanitary, "total", total);
      this.countCareHomePoints();
      this.countTotal();
    },
    countDisabledPoints() {
      var sum = 0;
      var maxPoints = 0;
      if(new Date(this.independantSettings.up_to_date) < this.newVersion){
        if (this.disabled.total_investment.value && parseFloat((this.disabled.total_investment.value + "").replace(",", ".") - parseFloat((this.disabled.disabled_subsidy.value + "").replace(",", ".")) > 0)) {
          var p = parseFloat((this.disabled.total_investment.points + "").replace(",", ".")) * Math.floor(parseFloat(((this.disabled.total_investment.value + "").replace(",", ".") - parseFloat((this.disabled.disabled_subsidy.value + "").replace(",", "."))) / this.independantLandlordSpendingsBase));
          sum += p;
          Vue.set(this.disabled.total_investment, "total", p);
        }
      }else{
        if (this.disabled.total_investment.value && parseFloat((this.disabled.total_investment.value + "").replace(",", ".")) > 0) {
          var p = parseFloat((this.disabled.total_investment.points + "").replace(",", ".")) * Math.floor(parseFloat((this.disabled.total_investment.value + "").replace(",", ".") / this.independantLandlordSpendingsBase));
          sum += p;
          Vue.set(this.disabled.total_investment, "total", p);
        }
      }

      var total = sum;
      Vue.set(this.disabled, "total", total);

      this.countCareHomePoints();
      this.countTotal();
    },
    countOutdoorPoints() {
      var sum = 0;
      if(new Date(this.independantSettings.up_to_date) < this.newVersion){
        if (this.outdoor.space.value && this.outdoorSpaces[this.outdoor.space.value]) {
          var points = parseFloat((this.outdoorSpaces[this.outdoor.space.value]["points"] + "").replace(",", "."));
          Vue.set(this.outdoor.space, "points", points);
          Vue.set(this.outdoor.space, "total", points);
          sum += points;
        }
        if (this.outdoor.carport.value && this.outdoor.carport.value == 1) {
          var p = parseFloat((this.outdoor.carport.points + "").replace(",", "."));
          Vue.set(this.outdoor.carport, "total", p);
          sum += p;
        }
      }else{
        if (this.outdoor.space.value && parseFloat((this.outdoorSpacesArea + "").replace(",", ".")) > 0) {
          var points = parseFloat((this.independantSettings.price_points_settings.outdoor.min_space_points+'').replace(",", ".")) + parseFloat((this.outdoorSpacesArea + "").replace(",", ".")) * parseFloat((this.outdoor.space.points+'').replace(",", "."));
          // Vue.set(this.outdoor.space, "points", points);
          Vue.set(this.outdoor.space, "total", points);
          sum += points;
        }
        if (this.outdoor.common_space.value && parseFloat((this.outdoorCommonSpacesArea + "").replace(",", ".")) > 0 && parseFloat((this.outdoorCommonSpacesAddresses + "").replace(",", ".")) > 0) {
          var p = (parseFloat((this.outdoorCommonSpacesArea + "").replace(",", ".")) * parseFloat((this.outdoor.common_space.points+'').replace(",", ".")))/parseFloat((this.outdoorCommonSpacesAddresses + "").replace(",", "."));
          // Vue.set(this.outdoor.common_space, "points", p);
          Vue.set(this.outdoor.common_space, "total", p);
          sum += p;
        }
        if (this.outdoorSpacesArea == 0 && this.outdoorCommonSpacesArea == 0) {
          var np = parseFloat((this.outdoor.common_space.negative_points+'').replace(',','.'));
          sum = sum - Math.abs(np);
        }
      }
      var total = sum;
      Vue.set(this.outdoor, "total", total);

      this.countCareHomePoints();
      this.countTotal();
    },
    countVopPoints() {
      var sum = 0;
      var price = this.vop.price.value;
      if (price > 0 && price < parseFloat(this.independantMinVopPrice)) {
        price = this.independantMinVopPrice;
      }

      var pointsPerSurface = 0;
      var absolute = 0;
      if (price) {
        absolute = (parseFloat(price) / parseFloat(this.independantVopPointPrice)).toFixed(2);
        if (
          this.vop.location.value &&
          this.muncipalities.includes(this.vop.location.value) &&
          this.surface < 40 &&
          this.surface > 0
        ) {
          pointsPerSurface = ((parseFloat(price) / parseFloat((this.surface+'').replace(',', '.'))) / parseFloat(this.independantVopProportionPriceAmsterdamUtrecht)).toFixed(2);
        } else if (this.surface > 0) {
          pointsPerSurface = ((parseFloat(price) / parseFloat((this.surface+'').replace(',', '.'))) / parseFloat(this.independantVopProportionPrice+'')).toFixed(2);
        }
      }
      

      var total = parseFloat(absolute) + parseFloat(pointsPerSurface);
      Vue.set(this.vop, "total", total);
      this.countCareHomePoints();
      var total = Math.round(total);
      Vue.set(this.vop, "absolute", absolute);
      Vue.set(this.vop, "surface_proportion", pointsPerSurface);
      Vue.set(this.vop, "total", total);

      this.countTotal();
      if(new Date(this.independantSettings.up_to_date) >= this.newVersion){      
        if(this.total - total >= 110 && total < 40){
          Vue.set(this.vop, "total", 40);
          this.countTotal();
        }
        if(this.total > 186 && !(this.vop.location.value && this.muncipalities.includes(this.vop.location.value) && this.surface < 40 && this.surface > 0) && total > (0.33 * this.total)){
          if(this.total >= 187){
            total = 0.33 * this.total;
            Vue.set(this.vop, "total", total);
            this.countTotal();
          }
          if(this.total < 187){
            this.total = 186;
          }
        }
      }
    },
    countRenovationPoints() {
      var sum = 0;
      var price = this.renovation.price.value;

      var total = 0;
      if (price >= 10000) {
        total = (price / 1000) * parseFloat((this.independantSettings.price_points_settings.renovation.price_points+'').replace(',', '.'));//0.2
      }
      Vue.set(this.renovation, "total", total);

      this.countCareHomePoints();
      this.countTotal();
    },
    countSharedParkingPoints() {
      var points = 0;
      if(parseFloat((this.sharedParking.number_of_addresses+'').replace(",", ".")) > 0){
        points = parseFloat((this.independantSettings.price_points_settings.shared_parking[this.sharedParking.type]+'').replace(',', '.')) / parseFloat((this.sharedParking.number_of_addresses+'').replace(",", "."));
      }
      Vue.set(this.sharedParking, "total", points);
      this.countTotal();
    },
    countCareHomePoints() {
      var sum = 0;
      var total = 0;
      if (this.careHome.value && this.careHome.value == 1) {
        total =
          this.leaveArea.total +
          this.otherSpaces.total +
          this.sharedParking.total +
          this.heating.total +
          this.energy.total +
          this.kitchen.total +
          this.sanitary.total +
          this.disabled.total +
          this.outdoor.total +
          this.vop.total +
          this.renovation.total;
        total = total * (parseFloat((this.careHome.points+'').replace(",", "."))/100);
      }
      if (this.careHome.has_automatic_bell && this.careHome.has_automatic_bell == 1) {
        total += parseFloat((this.careHome.automatic_bell_points).replace(",", "."));
      }
      Vue.set(this.careHome, "total", total);
      this.countTotal();
    },
    countMonumentAllowancePoints() {
      var sum = 0;
      var total = 0;
      if (this.monumentAllowance.value && this.monumentAllowance.value == 1) {
        total = 50;
      }
      Vue.set(this.monumentAllowance, "total", total);
      this.countTotal();
    },
    countTotal() {
      var total =
        this.leaveArea.total +
        this.otherSpaces.total +
        this.heating.total +
        this.energy.total +
        this.kitchen.total +
        this.sanitary.total +
        this.disabled.total +
        this.outdoor.total +
        this.sharedParking.total +
        this.vop.total +
        parseFloat((this.renovation.total+'').replace(",", ".")) +
        this.careHome.total +
        this.monumentAllowance.total;
      this.total = Math.round(total);
      this.totalPoints =
        this.total && parseFloat(this.total + "") > 40 ? this.total : 40;
      var p = this.totalPoints < 250 ? this.totalPoints : 250;
      this.price = this.independantMaxRentalPrices[p];
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/IndependantForm.vue